import _ from "lodash";
import { AlcoholData, DrunkDrink, Event, Photo } from "./slices/alcoholSlice";

export type Log =
  | {
      type: "drink";
      data: DrunkDrink;
    }
  | {
      type: "event";
      data: Event;
    }
  | {
      type: "photo";
      data: Photo;
    };

export type LogWithUserId = Log & { userId: string };

export default function getLogsFromAlcoholData(
  alcoholData:
    | {
        DrunkDrinks: DrunkDrink[];
        events: Event[];
        photos: Photo[];
      }
    | AlcoholData
) {
  if (!alcoholData) return [];

  const drunkDrinks = _.cloneDeep(alcoholData.DrunkDrinks);

  const events = _.cloneDeep(alcoholData.events ?? []);

  const photos = _.cloneDeep(alcoholData.photos ?? []);

  const logs: Log[] = [
    ...drunkDrinks.map((drink) => ({ data: drink, type: "drink" as const })),
    ...events.map((event) => ({ data: event, type: "event" as const })),
    ...photos.map((photo) => ({ data: photo, type: "photo" as const })),
  ].sort((a, b) => {
    return new Date(b.data.date).getTime() - new Date(a.data.date).getTime();
  });

  return logs;
}
